import { DateTime } from "luxon";
import { TimeFinderOption } from "../../../src/api/trpc/time-finder";

// Helper functions for cookie management

export function createDefaultTimeslot(
	date: DateTime
): TimeFinderOption["timeslots"][number] {
	const start_time_date = date.set({
		hour: 12,
		minute: 0,
		second: 0,
	});

	const end_time_date = start_time_date.plus({ hours: 1 });

	return {
		start_time: start_time_date.toMillis(),
		end_time: end_time_date.toMillis(),
	};
}
export function createNewTimeFinderOption(date: Date): TimeFinderOption {
	const luxonDate = DateTime.fromJSDate(date);

	return {
		date: {
			day: luxonDate.day,
			month: luxonDate.month,
			year: luxonDate.year,
		},
		timeslots: [createDefaultTimeslot(luxonDate)],
	};
}

export function updateSelectedDatesOnSpecifyTimeToggled(
	selectedDates: TimeFinderOption[]
) {
	selectedDates.map((selectedDate) => {
		if (!selectedDate.timeslots || selectedDate.timeslots.length === 0) {
			const date_obj = DateTime.fromObject(selectedDate.date);

			selectedDate.timeslots = [createDefaultTimeslot(date_obj)];
		}
	});

	return selectedDates;
}
